import React from 'react';
import { motion } from 'framer-motion';
export const Features: React.FC = () => {
  const features = [{
    title: 'El Cambio de Dinámica Emocional',
    label: 'Característica #1:',
    desc: 'Aprenderás cómo dejar de perseguir emocionalmente SIN fingir desinterés.',
    bullets: ['se vuelven demasiado disponibles', 'explican demasiado', 'entregan toda su energía demasiado rápido'],
    context: 'Porque la mayoría de las mujeres:',
    conclusion: 'Y eso mata la tensión emocional. Con este sistema aprenderás a recuperar misterio, calma y presencia emocional. Es como tener una ventaja psicológica que cambia completamente cómo él responde a ti.',
    img: 'https://cdn.magicpatterns.com/uploads/pmnW9iSUfjik9e8tuvsPt1/91_(13).png'
  }, {
    title: 'Guía Paso a Paso Para Frenar El Sobrepensamiento',
    label: 'Característica #2:',
    desc: 'Recibirás ejercicios y cambios mentales específicos para:',
    bullets: ['dejar de obsesionarte con mensajes', 'cortar ciclos de ansiedad emocional', 'dejar de revisar redes compulsivamente', 'recuperar paz mental'],
    context: '',
    conclusion: 'Sin tener que convertirte en alguien fría. Sin fingir indiferencia. Sin “juegos”.',
    img: 'https://cdn.magicpatterns.com/uploads/aNxPz3PN3CD2ZGjrdMGfH2/ChatGPT_Image_10_may_2026,_07_49_57_p.m..png'
  }, {
    title: 'Cómo Volverte Emocionalmente Inolvidable',
    label: 'Característica #3:',
    desc: 'La mayoría de mujeres intentan llamar atención. Esta guía te enseña algo MUCHO más poderoso: Cómo generar impacto emocional.',
    bullets: ['qué destruye la atracción silenciosamente', 'qué comportamientos hacen que un hombre pierda interés', 'cómo hacer que él te perciba diferente al resto'],
    context: 'Aprenderás:',
    conclusion: 'Cuando entiendes esto… la dinámica cambia completamente.',
    img: 'https://cdn.magicpatterns.com/uploads/8jvRyJUvfonzmqUjS9BUx2/bbib.jpg'
  }, {
    title: 'Psicología Masculina Simplificada',
    label: 'Característica #4:',
    desc: '',
    bullets: ['por qué los hombres se alejan', 'por qué vuelven', 'por qué pierden interés cuando sienten “demasiada seguridad”', 'por qué algunas mujeres generan obsesión sin esforzarse'],
    context: 'Entenderás:',
    conclusion: 'Sin teorías complicadas. Sin manipulación. Solo claridad emocional real.',
    img: 'https://cdn.magicpatterns.com/uploads/ojid6abwY8HcAJDy97XLG9/juntos.jpg'
  }, {
    title: 'Diseñado Para Mujeres Reales (No Influencers Perfectas)',
    label: 'Característica #5:',
    desc: 'No necesitas: ser modelo, actuar “inalcanzable”, tener miles de seguidores, fingir personalidad.',
    bullets: ['eres sensible', 'te cuesta soltar', 'te enamoras rápido', 'tienes ansiedad emocional', 'ya intentaste de todo'],
    context: 'Esta guía funciona incluso si:',
    conclusion: '',
    img: 'https://cdn.magicpatterns.com/uploads/ofJk7zPteGTZ91nMLAvAr2/imagen_bien.jpg'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-49">
      <div className="max-w-5xl mx-auto" data-id="element-50">
        <div className="text-center mb-16 md:mb-24" data-id="element-51">
          <h2 className="text-sm font-bold tracking-widest text-brand-gold uppercase mb-4" data-id="element-52">
            Presentando...
          </h2>
          <h3 className="text-3xl md:text-5xl font-serif font-bold text-brand-charcoal leading-tight mb-8" data-id="element-53">
            “La Guía Que Te Ayuda a Dejar de Darle Tantas Vueltas a Las Cosas,
            Cambiar La Dinámica y Convertirte en La Mujer Que Él Busca”
          </h3>
          <p className="text-xl text-brand-wine font-medium mb-12" data-id="element-54">
            El sistema emocional que transforma ansiedad en atracción.
          </p>

          <div className="max-w-2xl mx-auto bg-brand-rose p-8 rounded-2xl text-left" data-id="element-55">
            <h4 className="text-2xl font-serif font-bold mb-4" data-id="element-56">
              ¿Qué Hace Diferente A Esta Guía?
            </h4>
            <p className="mb-4" data-id="element-57">
              Simple. No es teoría motivacional. No son frases vacías. No es
              “haz manifestaciones bajo la luna llena”.
            </p>
            <p className="font-bold" data-id="element-58">
              Es una guía práctica diseñada para ayudarte a recuperar el control
              emocional y cambiar la percepción que los hombres tienen de ti.
            </p>
          </div>
        </div>

        <div className="md:space-y-32 space-y-[3px]" data-id="element-59">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className={`flex flex-col gap-8 md:gap-16 items-center ${idx % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'}`} data-id="element-60">
              <div className="w-full md:w-1/2" data-id="element-61">
                <div className="aspect-[4/5] rounded-3xl overflow-hidden shadow-xl" data-id="element-62">
                  <img src={feature.img} alt={feature.title} className="w-full h-full object-cover" data-id="element-63" />
                </div>
              </div>

              <div className="w-full md:w-1/2 space-y-6 text-lg" data-id="element-64">
                <div data-id="element-65">
                  <span className="text-brand-gold font-bold tracking-wider uppercase text-sm" data-id="element-66">
                    {feature.label}
                  </span>
                  <h3 className="text-2xl md:text-3xl font-serif font-bold text-brand-charcoal mt-2" data-id="element-67">
                    {feature.title}
                  </h3>
                </div>

                {feature.desc && <p className="text-gray-700" data-id="element-68">{feature.desc}</p>}

                {feature.context && <p className="font-medium text-gray-900" data-id="element-69">{feature.context}</p>}

                <ul className="space-y-3 pl-4 border-l-2 border-brand-blush" data-id="element-70">
                  {feature.bullets.map((bullet, bIdx) => <li key={bIdx} className="text-gray-700 relative before:content-['•'] before:absolute before:-left-4 before:text-brand-wine" data-id="element-71">
                      {bullet}
                    </li>)}
                </ul>

                {feature.conclusion && <p className="text-gray-700 font-medium italic" data-id="element-72">
                    {feature.conclusion}
                  </p>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};